
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-hub",
      function () {
        return require("private-next-pages/privacy-hub.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-hub"])
      });
    }
  